var isReady = false;
var sameOrigin = '';
var mh = '100%';

if (window.addEventListener) {
  window.addEventListener('message', function(e) {
    if (e.origin !== sameOrigin && sameOrigin !== '*'){
      return;
    }
    return onMessage(e)
  }, false);
  window.addEventListener('scroll', function(e) {
    if (e.origin !== sameOrigin && sameOrigin !== '*'){
      return;
    }
    return messageScroll(e)
  }, false);
} else if (window.attachEvent) {
  window.addEventListener('onmessage', function(e) {
    if (e.origin !== sameOrigin && sameOrigin !== '*'){
      return;
    }
    return onMessage(e)
  }, false);
}

function onMessage(event) {
  if (event.data.noPartner) {
    var data = event.data;
    var element = document.getElementById('mst-iframe');
    if (data.height && element) {
      const searchParams = new URLSearchParams(element.src);
      if (window.innerWidth > 1009 || (searchParams.get('h') && searchParams.get('h') === '1')) {
        element.style.height = data.height + 'px';
      }
    }
    // PEZZA PER MICROGAME
    if (data.mobileHeight && element && window.innerWidth < 1200 ) {
      if (mh === '100%') {
        mh = window.getComputedStyle(element, null).getPropertyValue('height');
        element.style.height = 'calc(' + mh + ' - ' + data.mobileHeight + 'px' + ')';
        element.style.minHeight = 'calc(' + mh + ' - ' + data.mobileHeight + 'px' + ')';
        element.style.maxHeight = 'calc(' + mh + ' - ' + data.mobileHeight + 'px' + ')';
      }
    }
    if (data.func && typeof window[data.func] == 'function') {
      if (data.param) {
        window[data.func].call(data.param);
      } else {
        window[data.func].call(null);
      }
    }
  }
}

function GetHorses(opts) {
  sameOrigin = opts.urlSite.replace(/\/$/, '');
  var elem = document.getElementById('mst-iframe');
  if (elem) {
    elem.src = getIppicaUrl(opts);
    elem.contentWindow.postMessage(opts, sameOrigin);
  } else {
    var div = document.getElementById('mst-content');
    var elemIframe = document.createElement('iframe');
    elemIframe.id = 'mst-iframe';
    elemIframe.name = 'mst-iframe';
    elemIframe.height = '100%';
    elemIframe.width = '100%';
    elemIframe.style.minHeight = 'calc(100vh - 125px)';
    elemIframe.style.minWidth = '100%';
    elemIframe.scrolling = 'no';
    elemIframe.frameBorder = '0';
    elemIframe.marginWidth = '0';
    elemIframe.marginHeight = '0';
    elemIframe.allowFullscreen = 'true';
    elemIframe.src = getIppicaUrl(opts);
    elemIframe.addEventListener('load', function () {
      var element = document.getElementById('mst-iframe');
      if (element) {
        element.contentWindow.postMessage(opts, sameOrigin);
      }
    });
    if (window.innerWidth < 1200) {
      elemIframe.scrolling = 'no';
      var html = document.getElementsByTagName('html');
      html[0].style.height = '100%';
      var style = window.getComputedStyle(html[0], null);
      var h = style.getPropertyValue('height');
      //html[0].style.overflow = 'hidden';
      var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';
      // console.log(topmobile);
      // console.log(h);
      // if (opts.classTopMobile && opts.classTopMobile != '') {
      //   var top =  document.getElementsByClassName(opts.classTopMobile);
      //   for (var i=0; i < top.length; i++){
      //     topmobile+= top[i].offsetHeight;
      //   }
      //   topmobile+= 'px';
      // }else{
      //   topmobile = '0px';
      // }
      elemIframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
      elemIframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';
      elemIframe.style.height = 'calc(' + h + ' - '+topmobile+')';

      // Detect whether device supports orientationchange event, otherwise fall back to
      // the resize event.
      var supportsOrientationChange = "onorientationchange" in window,
          orientationEvent = supportsOrientationChange ? "orientationchange" : null;

      window.addEventListener(orientationEvent, function() {
        var Iframe = document.getElementById('mst-iframe');
        if(window.orientation && Iframe){
          var html = document.getElementsByTagName('html');
          html[0].style.height = '100%';
          var style = window.getComputedStyle(html[0], null);
          var h = style.getPropertyValue('height');
          //html[0].style.overflow = 'hidden';
          var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';
          // if (opts.classTopMobile && opts.classTopMobile != '') {
          //   var top =  document.getElementsByClassName(opts.classTopMobile);
          //   for (var i=0; i < top.length; i++){
          //     topmobile+= top[i].offsetHeight;
          //   }
          //   topmobile+= 'px';
          // }else{
          //   topmobile = '50px';
          // }
          Iframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.height = 'calc(' + h + ' - '+topmobile+')';
        }
      }, false);
    }
    div.appendChild(elemIframe);
  }
}

function GetHorsesBetsList(opts) {
  sameOrigin = opts.urlSite.replace(/\/$/, '');
  var elem = document.getElementById('mst-iframe');
  if (elem) {
    elem.src = getGiocateUrl(opts);
    elem.contentWindow.postMessage(opts, sameOrigin);
  } else {
    var div = document.getElementById('mst-content');
    var elemIframe = document.createElement('iframe');
    elemIframe.id = 'mst-iframe';
    elemIframe.name = 'mst-iframe';
    elemIframe.height = '100%';
    elemIframe.width = '100%';
    // elemIframe.style.minHeight = 'calc(100vh - 125px)';
    elemIframe.style.minWidth = '100%';
    elemIframe.scrolling = 'no';
    elemIframe.frameBorder = '0';
    elemIframe.marginWidth = '0';
    elemIframe.marginHeight = '0';
    elemIframe.allowFullscreen = 'true';
    elemIframe.src = getGiocateUrl(opts);
    elemIframe.addEventListener('load', function () {
      var element = document.getElementById('mst-iframe');
      if (element) {
        element.contentWindow.postMessage(opts, sameOrigin);
      }
    });
    if (window.innerWidth < 1200) {
      elemIframe.scrolling = 'no';
      var html = document.getElementsByTagName('html');
      html[0].style.height = '100%';
      var style = window.getComputedStyle(html[0], null);
      var h = style.getPropertyValue('height');
      //html[0].style.overflow = 'hidden';
      var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';
      // if (opts.classTopMobile && opts.classTopMobile != '') {
      //   var top =  document.getElementsByClassName(opts.classTopMobile);
      //   for (var i=0; i < top.length; i++){
      //     topmobile+= top[i].offsetHeight;
      //   }
      //   topmobile+= 'px';
      // }else{
      //   topmobile = '50px';
      // }
      elemIframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
      elemIframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';
      elemIframe.style.height = 'calc(' + h + ' - '+topmobile+')';

      // Detect whether device supports orientationchange event, otherwise fall back to
      // the resize event.
      var supportsOrientationChange = "onorientationchange" in window,
          orientationEvent = supportsOrientationChange ? "orientationchange" : null;

      window.addEventListener(orientationEvent, function() {
        var Iframe = document.getElementById('mst-iframe');
        if(window.orientation && Iframe){
          var html = document.getElementsByTagName('html');
          html[0].style.height = '100%';
          var style = window.getComputedStyle(html[0], null);
          var h = style.getPropertyValue('height');
          //html[0].style.overflow = 'hidden';
          var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';
          // if (opts.classTopMobile && opts.classTopMobile != '') {
          //   var top =  document.getElementsByClassName(opts.classTopMobile);
          //   for (var i=0; i < top.length; i++){
          //     topmobile+= top[i].offsetHeight;
          //   }
          //   topmobile+= 'px';
          // }else{
          //   topmobile = '50px';
          // }
          Iframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.height = 'calc(' + h + ' - '+topmobile+')';
        }
      }, false);
    }
    div.appendChild(elemIframe);
  }
}

function GetHorsesTicket(opts) {
  console.log(opts);
  sameOrigin = opts.urlSite.replace(/\/$/, '');
  var elem = document.getElementById('mst-iframe');
  if (elem) {
    elem.src = getTicketDetailsUrl(opts);
  } else {
    var div = document.getElementById('mst-content');
    var elemIframe = document.createElement('iframe');
    elemIframe.id = 'mst-iframe';
    elemIframe.name = 'mst-iframe';
    elemIframe.height = '100%';
    elemIframe.width = '100%';
    elemIframe.style.minWidth = '100%';
    elemIframe.scrolling = 'no';
    elemIframe.frameBorder = '0';
    elemIframe.marginWidth = '0';
    elemIframe.marginHeight = '0';
    elemIframe.allowFullscreen = 'true';
    elemIframe.src = getTicketDetailsUrl(opts);
    if (window.innerWidth < 1200) {
      elemIframe.scrolling = 'yes';
      var html = document.getElementsByTagName('html');
      html[0].style.height = '100%';
      var style = window.getComputedStyle(html[0], null);
      var h = style.getPropertyValue('height');
      //html[0].style.overflow = 'hidden';
      var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';
      // if (opts.classTopMobile && opts.classTopMobile != '') {
      //   var top =  document.getElementsByClassName(opts.classTopMobile);
      //   for (var i=0; i < top.length; i++){
      //     topmobile+= top[i].offsetHeight;
      //   }
      //   topmobile+= 'px';
      // }else{
      //   topmobile = '50px';
      // }
      elemIframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
      elemIframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';

      // Detect whether device supports orientationchange event, otherwise fall back to
      // the resize event.
      var supportsOrientationChange = "onorientationchange" in window,
          orientationEvent = supportsOrientationChange ? "orientationchange" : null;

      window.addEventListener(orientationEvent, function() {
        var Iframe = document.getElementById('mst-iframe');
        if(window.orientation && Iframe){
          var html = document.getElementsByTagName('html');
          html[0].style.height = '100%';
          var style = window.getComputedStyle(html[0], null);
          var h = style.getPropertyValue('height');
          //html[0].style.overflow = 'hidden';
          var topmobile = document.getElementById('mst-content').getBoundingClientRect().top + 'px';;
          // if (opts.classTopMobile && opts.classTopMobile != '') {
          //   var top =  document.getElementsByClassName(opts.classTopMobile);
          //   for (var i=0; i < top.length; i++){
          //     topmobile+= top[i].offsetHeight;
          //   }
          //   topmobile+= 'px';
          // }else{
          //   topmobile = '50px';
          // }
          Iframe.style.maxHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.minHeight = 'calc(' + h + ' - '+topmobile+')';
          Iframe.style.height = 'calc(' + h + ' - '+topmobile+')';
        }
      }, false);
    }
    div.appendChild(elemIframe);
  }
}

function UpdateHorses(opts) {
  if (opts.urlSite && opts.urlSite !== ''){
    sameOrigin = opts.urlSite.replace(/\/$/, '');
  }
  if (opts.terminalTag) {
    sameOrigin = '*';
    isReady = true;
  }

  var elem = document.getElementById('mst-iframe');
  if (opts.sID === '' || opts.sID === null ) {
    opts.sID = 'LOGOUT';
  }
  if (elem && isReady) {
    elem.contentWindow.postMessage(opts, sameOrigin);
  }else {
    setTimeout(function (){
      UpdateHorses(opts)
    }, 2000)
    // UpdateHorses(opts);
  }
}

function getIppicaUrl(opts) {
  var UrlIppica;
  const crypto = window.crypto || window.msCrypto;
  var array = new Uint32Array(1);

  if (opts.urlSite != '' && opts.cID != '') {
    if(opts.raceid && opts.raceid !== '') {
      UrlIppica =
          opts.urlSite +
          '/pages/race/' +
          String(opts.raceid) +
          '?cID=' +
          opts.cID;
    }else{
      UrlIppica =
          opts.urlSite +
          '/pages/index?rand=' +
          //Math.round(Math.random() * 10000000) +
          crypto.getRandomValues(array) +
          '&cID=' +
          opts.cID;

    }
    if (opts.sID != '') {
      UrlIppica += '&sID=' + opts.sID;
    }
    if (opts.language != '' && opts.language != undefined) {
      UrlIppica += '&language=' + opts.language;
    }
    if (opts.OnCompleteBet != '') {
      UrlIppica += '&F_CB=' + opts.OnCompleteBet;
    }
    if (opts.OnClickBetBtn != '') {
      UrlIppica += '&F_OCB=' + opts.OnClickBetBtn;
    }
    if (opts.TrackGA != '') {
      UrlIppica += '&gTRC=' + opts.TrackGA;
    }
    if (opts.customCss != '' && opts.customCss != undefined) {
      UrlIppica += '&cCSS=1';
    }
    if (opts.videoenabled === false || opts.videoenabled === 'false') {
      UrlIppica += '&vEN=' + opts.videoenabled;
    }
    if (opts.showticketlisticon === false || opts.showticketlisticon === 'false') {
      UrlIppica += '&sTL=' + opts.showticketlisticon;
    }
      if (opts.terminalTag) {
          UrlIppica += '&inapp=' + opts.terminalTag;
      }
  } else {
    UrlIppica = opts.urlSite + '/error.html?code=501';
  }
  return UrlIppica;
}

function getGiocateUrl(opts) {
  const crypto = window.crypto || window.msCrypto;
  var array = new Uint32Array(1);
  var UrlIppica;
  if (!opts.urlSite) {
    opts.urlSite = 'https://staging-container-mst.azurewebsites.net';
  }

  if (opts.urlSite != '' && opts.cID != '') {
    UrlIppica =
        opts.urlSite + '/tickets?rand=' +  crypto.getRandomValues(array) + '&cID=' + opts.cID + '&h=1';
    if (opts.sID != '') {
      UrlIppica += '&sID=' + opts.sID;
    }
  } else {
    UrlIppica = opts.urlSite + '/error.html?code=501';
  }
  if (opts.customCss != '' && opts.customCss != undefined) {
    UrlIppica += '&cCSS=1';
  }
  if (opts.terminalTag) {
      UrlIppica += '&inapp=' + opts.terminalTag;
  }
  return UrlIppica;
}

function getTicketDetailsUrl(opts) {
  var UrlIppica;
  const crypto = window.crypto || window.msCrypto;
  var array = new Uint32Array(1);
  if (!opts.urlSite) {
    opts.urlSite = 'https://staging-container-mst.azurewebsites.net';
  }

  if (opts.urlSite != '' && opts.cID != '' && opts.tID != '') {
    UrlIppica =
        opts.urlSite +
        '/ticketdetails?rand=' +
        crypto.getRandomValues(array) +
        '&cID=' +
        opts.cID +
        '&tID=' +
        opts.tID +
        '&sID=' +
        opts.sID;
  } else {
    UrlIppica = opts.urlSite + '/error.html?code=501';
  }
  if (opts.customCss != '' && opts.customCss != undefined) {
    UrlIppica += '&cCSS=1';
  }
    if (opts.terminalTag) {
        UrlIppica += '&inapp=' + opts.terminalTag;
    }
  return UrlIppica;
}

function StopVideo(opts) {
  if (opts.urlSite && opts.urlSite !== ''){
    sameOrigin = opts.urlSite.replace(/\/$/, '');
  }
  var elem = document.getElementById('mst-iframe');
  if (elem) {
    opts.playvideo = 'false';
    elem.contentWindow.postMessage(opts, sameOrigin);
  }
}

function StartVideo(opts) {
  if (opts.urlSite && opts.urlSite !== ''){
    sameOrigin = opts.urlSite.replace(/\/$/, '');
  }
  var elem = document.getElementById('mst-iframe');
  if (elem) {
    opts.playvideo = 'true';
    elem.contentWindow.postMessage(opts, sameOrigin);
  }
}

function scrollTop(){
  var elem = document.getElementById('mst-iframe');
  if (window.innerWidth > 1009) {
    window.scroll({
      top: elem.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  }else{
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}

function scrollTopHandToHAnd(){
  var elem = document.getElementById('mst-iframe');
  if (window.innerWidth > 1009) {
    window.scroll({
      top: this.top - elem.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  }else{
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
}

function getIsReady(){
  isReady = true;
}

function messageScroll(event) {
  var elem = document.getElementById('mst-iframe');
  if (elem && isReady) {
    elem.contentWindow.postMessage({scroll: {y: window.scrollY, iframeTop: elem.offsetTop}}, sameOrigin);
  }
}

